import { registerQuery, useQuery } from 'data-fetching-client';
import UsersSearchApi from '../api/UsersSearchApi';
const FETCH_USERS = registerQuery({
  fieldName: 'users',
  args: ['includedUserIds', 'excludedUserIds'],
  fetcher({
    includedUserIds,
    excludedUserIds
  }) {
    return UsersSearchApi.searchUsers({
      limit: includedUserIds.length,
      mustMatchUserIds: includedUserIds,
      mustNotMatchUserIds: excludedUserIds
    });
  }
});
const useBulkFetchUsers = (includedUserIds, excludedUserIds) => {
  var _data$users;
  const {
    loading,
    error,
    data
  } = useQuery(FETCH_USERS, {
    variables: {
      includedUserIds,
      excludedUserIds
    },
    skip: !includedUserIds.length && !(excludedUserIds !== null && excludedUserIds !== void 0 && excludedUserIds.length)
  });
  if (data !== null && data !== void 0 && (_data$users = data.users) !== null && _data$users !== void 0 && _data$users.results) {
    const transformedUsers = data.users.results.map(user => ({
      firstName: user.first_name,
      lastName: user.last_name,
      id: user.user_id,
      email: user.email
    }));
    return {
      loading,
      error,
      users: transformedUsers
    };
  }
  return {
    loading,
    error,
    users: []
  };
};
export default useBulkFetchUsers;